"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MolecularSequence_Roc = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_integer_1 = require("../Scalar/RTTI_integer");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_decimal_1 = require("../Scalar/RTTI_decimal");
exports.RTTI_MolecularSequence_Roc = t.recursion('IMolecularSequence_Roc', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        score: t.array(RTTI_integer_1.RTTI_integer),
        _score: t.array(RTTI_Element_1.RTTI_Element),
        numTP: t.array(RTTI_integer_1.RTTI_integer),
        _numTP: t.array(RTTI_Element_1.RTTI_Element),
        numFP: t.array(RTTI_integer_1.RTTI_integer),
        _numFP: t.array(RTTI_Element_1.RTTI_Element),
        numFN: t.array(RTTI_integer_1.RTTI_integer),
        _numFN: t.array(RTTI_Element_1.RTTI_Element),
        precision: t.array(RTTI_decimal_1.RTTI_decimal),
        _precision: t.array(RTTI_Element_1.RTTI_Element),
        sensitivity: t.array(RTTI_decimal_1.RTTI_decimal),
        _sensitivity: t.array(RTTI_Element_1.RTTI_Element),
        fMeasure: t.array(RTTI_decimal_1.RTTI_decimal),
        _fMeasure: t.array(RTTI_Element_1.RTTI_Element)
    });
});
//# sourceMappingURL=RTTI_MolecularSequence_Roc.js.map